import React from 'react';
import { Container,Navbar } from 'react-bootstrap';
import '../../css/header.css';

class Header extends React.Component{
    render(){
        return(
            <Navbar variant="dark" className="nav-color mb-4">
                <Container>
                <Navbar.Brand href="#home">
                <img
                    src="../images/logo.png"
                    height="50"
                    className="d-inline-block align-top"
                    alt="React Bootstrap logo"
                />
                </Navbar.Brand>
                </Container>
            </Navbar>
        )
    }
}

export default Header;